
export const Planos = () =>{
    return (
      <h1>PLANOS</h1>
    )
}
